import type { Icon } from 'app/design/icons';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useNavigation } from 'app/hooks/navigation';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useUISize } from 'app/utils/web-helpers';
import { Trans } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronRight } from '@tabler/icons-react-native';
const theme = createDSTheme();

function ProfileSection({
  title,
  links,
}: {
  title: string;
  links: { label: string; Prefix: Icon; routeName: string; onPress: () => void }[];
}) {
  const navigation = useNavigation();
  const { isLargeUI } = useUISize();
  const navigationState = navigation.getState();
  const currentRoute = navigationState.routes[navigationState.index]?.name;

  return (
    <Column marginTop="spacing.general.x8">
      <Text
        fontWeight="600"
        paddingBottom="spacing.general.x4"
        textAlign={isLargeUI ? 'left' : 'center'}
        variant="headerXSmall"
      >
        {title}
      </Text>

      <Column
        backgroundColor={isLargeUI ? undefined : 'surface.primary-neutral'}
        borderRadius="radius.xl"
        paddingVertical="spacing.general.x2"
      >
        {links.map(({ label, Prefix, routeName, onPress }) => {
          const shouldHighlight = currentRoute === routeName && navigation.isFocused();

          return (
            <Button
              style={{
                backgroundColor: shouldHighlight ? theme.colors['surface.tertiary-neutral'] : 'transparent',
              }}
              key={label}
              onPress={onPress}
              prefix={<Prefix height={32} width={32} strokeWidth={ICON_STROKE_WIDTH} />}
              suffix={<IconChevronRight strokeWidth={ICON_STROKE_WIDTH} />}
            >
              <Text flex={1} numberOfLines={1}>
                <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={label} ns="profile-overview" />
              </Text>
            </Button>
          );
        })}
      </Column>
    </Column>
  );
}

export default ProfileSection;
